import React from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { motion } from 'framer-motion';
import { useUnreadNotificationCount } from '../../hooks/useUnreadNotificationCount';

// NotificationBell component - Displays a bell icon with unread count in the header
const NotificationBell = () => {
  const unreadCount = useUnreadNotificationCount();

  const bellVariants = {
    hover: { scale: 1.1, rotate: [0, 15, -15, 0] },
    tap: { scale: 0.95 },
  };

  return (
    <Link to="/notifications" className="relative">
      <motion.div
        variants={bellVariants}
        whileHover="hover"
        whileTap="tap"
        className="p-2"
      >
        <Bell className="h-6 w-6" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-error text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
            {unreadCount}
          </span>
        )}
      </motion.div>
    </Link>
  );
};

export default NotificationBell;
